//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PermissionModal from "./modules/PermissionModal";
import { getPermissionList } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import PermissionUserRoleModal from "./modules/PermissionUserRoleModal";
import PermissionDataRuleList from "./PermissionDataRuleList";
import JEllipsis from '@/components/jeecg/JEllipsis';
import { getAction } from "../../api/manage";
var columns = [{
  title: '菜单名称',
  dataIndex: 'name',
  key: 'name'
}, {
  title: '菜单类型',
  align: 'center',
  dataIndex: 'menuType',
  key: 'menuType',
  customRender: function customRender(text) {
    if (text == 0) {
      return '菜单';
    } else if (text == 1) {
      return '菜单';
    } else if (text == 2) {
      return '按钮';
    } else {
      return text;
    }
  }
},
/*{
    title: '权限编码',
    dataIndex: 'perms',
    key: 'permissionCode',
  },*/
{
  title: 'icon',
  dataIndex: 'icon',
  align: 'center',
  key: 'icon'
}, {
  title: '组件',
  dataIndex: 'component',
  align: 'center',
  key: 'component',
  scopedSlots: {
    customRender: 'component'
  }
}, {
  title: '路径',
  dataIndex: 'url',
  align: 'center',
  key: 'url',
  scopedSlots: {
    customRender: 'url'
  }
}, {
  title: '排序',
  dataIndex: 'sortNo',
  align: 'center',
  key: 'sortNo'
}, {
  title: '操作',
  dataIndex: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: 150
}];
export default {
  name: 'PermissionList',
  mixins: [JeecgListMixin],
  components: {
    PermissionDataRuleList: PermissionDataRuleList,
    PermissionModal: PermissionModal,
    PermissionUserRoleModal: PermissionUserRoleModal,
    JEllipsis: JEllipsis
  },
  data: function data() {
    return {
      description: '这是菜单管理页面',
      // 表头
      columns: columns,
      loading: false,
      url: {
        list: '/sys/permission/list',
        // permission: '/sys/permission/list/one',
        delete: '/sys/permission/delete',
        deleteBatch: '/sys/permission/deleteBatch'
      }
    };
  },
  created: function created() {// this.loadPermission()
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      this.dataSource = [];
      getPermissionList().then(function (res) {
        if (res.success) {
          _this.dataSource = res.result;
        }
      });
    },
    // loadPermission() {
    //   getAction(this.url.permission).then(res => {
    //     if (res.success) {
    //     }
    //   })
    // },
    //菜单反向配置角色
    handleRole: function handleRole(record) {
      this.$refs.roleModal.title = '角色配置';
      this.$refs.roleModal.edit({
        permissionId: record.id
      });
    },
    // 打开数据规则编辑
    handleDataRule: function handleDataRule(record) {
      this.$refs.PermissionDataRuleList.edit(record);
    },
    handleAddSub: function handleAddSub(record) {
      this.$refs.modalForm.title = '添加子菜单';
      this.$refs.modalForm.localMenuType = 1;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.edit({
        status: '1',
        permsType: '1',
        route: true,
        parentId: record.id,
        path: record.path
      });
    }
  }
};